import axios from "axios";
import { authHeaderJson, authHeaderTextPlain } from "../auth-header.service";
import moment from "moment";
import { requestExportToken } from "../export.service";

const getListObligationConrtacts = (obligacion_id) => {
    return axios.get(`/api/ObligacionElement/obligacionelement/contracts/list/${obligacion_id}`, { headers: authHeaderJson() } );
};

const addListObligationContracts = (obligationId, itemList) => {
    return axios.post(`/api/ObligacionElement/obligacionelement/contracts/add/list/${obligationId}`, itemList, { headers: authHeaderJson() } )
};

const getHomeContractObligationAchieves = () => {
    return axios.get(`/api/ObligacionElement/obligacionelement/home/list`, { headers: authHeaderJson() } );
};

const getHomeContractObligationAchievesExport = async (itemToSend) => {
    const token = await requestExportToken("obligacionelement/home/list/export");
    return axios.post(`/api/ObligacionElement/obligacionelement/home/list/export?exportToken=${token}`, itemToSend, { headers: authHeaderJson() });
};

const getObligationElementList = (element_id) => {
    return axios.get(`/api/ObligacionElement/obligacionelement/get/list/${element_id}`, { headers: authHeaderJson() } );
};

const getObligationElement = (element_id, obligacion_id) => {
    return axios.get(`/api/ObligacionElement/obligacionelement/get/${element_id}/${obligacion_id}`, { headers: authHeaderJson() } );
};

const getObligationAchieveElementExport = async (itemToSend) => {
    const token = await requestExportToken("obligacionelement/cumplimiento/export");
    return axios.post(`/api/ObligacionElement/obligacionelement/cumplimiento/export?exportToken=${token}`, itemToSend, { headers: authHeaderJson() });
};

const getObligationAchieveElement = (element_id, obligacion_id) => {
    return axios.get(`/api/ObligacionCumplimiento/cumplimiento/list/${element_id}/${obligacion_id}`, { headers: authHeaderJson() } );
};

const activateOgligation = (element_id, obligacion_id, fecha_proximo_vencimiento) => {
    let qs_fechaProximoVencimiento = fecha_proximo_vencimiento !== null ? `fecha_proximo_vencimiento=${encodeURIComponent(moment(fecha_proximo_vencimiento).format('MM/DD/YYYY'))}` : '';
    let url = `/api/ObligacionElement/obligacionelement/activate/${obligacion_id}/${element_id}`
    if(qs_fechaProximoVencimiento !== '' ) { url = url + '?' + qs_fechaProximoVencimiento }

    return axios.request({ method: 'post', maxBodyLength: Infinity, url: url, headers:authHeaderTextPlain()})
};

const deactivateOgligation = (element_id, obligacion_id, fecha_proximo_vencimiento) => {
    let qs_fechaProximoVencimiento = fecha_proximo_vencimiento !== null ? `fecha_proximo_vencimiento=${encodeURIComponent(moment(fecha_proximo_vencimiento).format('MM/DD/YYYY'))}` : '';
    let url = `/api/ObligacionElement/obligacionelement/deactivate/${obligacion_id}/${element_id}`
    if(qs_fechaProximoVencimiento !== '' ) { url = url + '?' + qs_fechaProximoVencimiento }

    return axios.request({ method: 'post', maxBodyLength: Infinity, url: url, headers:authHeaderTextPlain()})
};

const setNexDueDateOgligation = (element_id, obligacion_id, fecha_proximo_vencimiento) => {
    let qs_fechaProximoVencimiento = fecha_proximo_vencimiento !== null ? `fecha_proximo_vencimiento=${encodeURIComponent(moment(fecha_proximo_vencimiento).format('MM/DD/YYYY'))}` : '';
    let url = `/api/ObligacionElement/obligacionelement/expireddate/${obligacion_id}/${element_id}`
    if(qs_fechaProximoVencimiento !== '' ) { url = url + '?' + qs_fechaProximoVencimiento }

    return axios.request({ method: 'post', maxBodyLength: Infinity, url: url, headers:authHeaderTextPlain()})
};

export {
    activateOgligation,
    deactivateOgligation,
    getListObligationConrtacts,
    addListObligationContracts,
    getHomeContractObligationAchieves,
    getObligationElementList,
    getObligationElement,
    getObligationAchieveElement,
    getObligationAchieveElementExport,
    setNexDueDateOgligation,
    getHomeContractObligationAchievesExport
}